<template>
  <el-backtop
    class="to-top-btn"
    :bottom="150"
    :right="50"
    :style="{
      background: backgroundColor,
      color: color,
    }"
  >
    <i class="el-icon-arrow-up" />
  </el-backtop>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'backTop',
  computed: {
    ...mapState({
      backgroundColor: ({ options }) => options?.theme?.modules?.nav?.top_btn_background_color,
      color: ({ options }) => options?.theme?.modules?.nav?.top_btn_arrow,
    }),
  },
}
</script>
<style scoped lang='scss'>
.to-top-btn {
  width: 44px;
  height: 44px;
  color: gray;
  background-color: #fff;
  box-shadow: 0 0 5px #80808082;
  bottom: -100px;
  z-index: 999;
  font-size: 20px;
  font-weight: bold;
  transition: all ease-in-out 0.2s;
  @media screen and (max-width: 767px) {
    right: 10px !important;
    bottom: 80px !important;
  }
}
</style>